import { createContext, useContext } from 'react';

import { JabraSitecoreTheme } from './JabraTheme.models';

export const JabraThemesListContext = createContext<JabraSitecoreTheme[]>([]);

export const useJabraThemesList = () => {
  return useContext(JabraThemesListContext);
};
